import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const lerFiltros = (parametros) => ({
  q: parametros.get('q') ?? '',
  status: parametros.getAll('status'),
  areaCursoId: parametros.get('areaCursoId') ?? '',
  tipoAtividade: parametros.get('tipoAtividade') ?? '',
  unidadeAssistencialId: parametros.get('unidadeAssistencialId') ?? '',
  periodoInicio: parametros.get('periodoInicio') ?? '',
  periodoFim: parametros.get('periodoFim') ?? '',
  ordenarPor: parametros.get('ordenarPor') ?? '',
  ordem: parametros.get('ordem') ?? '',
});

export function useFiltrosRelatorio() {
  const [parametros, setParametros] = useSearchParams();
  const consulta = parametros.toString();

  const filtros = useMemo(() => lerFiltros(new URLSearchParams(consulta)), [consulta]);

  const atualizar = useCallback(
    (alteracoes) => {
      setParametros(
        (atuais) => {
          const novos = new URLSearchParams(atuais);
          Object.entries(alteracoes).forEach(([chave, valor]) => {
            novos.delete(chave);
            if (Array.isArray(valor)) {
              valor.forEach((item) => novos.append(chave, item));
            } else if (valor !== undefined && valor !== null && valor !== '') {
              novos.set(chave, valor);
            }
          });
          return novos;
        },
        { replace: true }
      );
    },
    [setParametros]
  );

  return { filtros, atualizar };
}
